// extracted by mini-css-extract-plugin
export default {"exclusionGroup":"ExclusionOverlaySection_exclusionGroup__56bIi"};